import { Card } from '@mantine/core'
import withErrorBoundaryAndPolicyCheck from '@v2/commons/HOC/ErrorBoundaryAndPolicyCheckHOC'
import { POLICIES } from '@v2/commons/config'
import BasicTemplate from '@v2/commons/templates/BasicTemplate'

import EnrollmentResult from './components/EnrollmentResult.component'
import Header from './components/Header.component'
import SearchForm from './components/SearchForm.component'
import useSearchEnrollmentChecker from './hooks/useSearchEnrollmentChecker'

const EnrollmentCheckerView = () => {
  const {
    searchEnrollmentChecker,
    data,
    isLoading,
    isError,
    isUninitialized,
    searchTerm,
  } = useSearchEnrollmentChecker()

  return (
    <BasicTemplate>
      <Card style={{ height: '80vh' }}>
        <Header />
        <SearchForm searchEnrollmentChecker={searchEnrollmentChecker} />
        <EnrollmentResult
          data={data}
          searchTerm={searchTerm}
          isLoading={isLoading}
          isError={isError}
          isUninitialized={isUninitialized}
        />
      </Card>
    </BasicTemplate>
  )
}

export default withErrorBoundaryAndPolicyCheck(
  EnrollmentCheckerView,
  POLICIES.isEnrollmentCheckerVendorsEnabled,
)
